import { securityTypeConfig } from '../const';
import { isEmpty } from "lodash";

export const getInitWirelessData = ({
  wirelessData
}) => {
  if (!wirelessData) return [];

  return wirelessData.map(ssid => {
    return {
      ...ssid,
      isWaitingRemove: false,
      captivePortalName: ssid?.captivePortalName || 'disabled',
      macFilter: ssid?.macFilter || 'disabled',
      ipFilter: ssid?.ipFilter || 'disabled',
      wirelessSchedule: ssid?.wirelessSchedule || 'disabled',
    }
  })
}

export const getSendRequestParams = ({
  auth,
  method = "read"
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiUrl = `${apiBaseUrl}/sites/:siteId/settings/wirelessNetworks.${method}`;

  const requestParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const requestParams = isStandaloneMode ? requestParamsConfig["standalone"] : requestParamsConfig["nonStandalone"];

  return {
    apiUrl,
    requestParams
  };
}

export const getCleanUpdatePayload = ({
  wirelessData
}) => {

  let payload = {
    data: {
      create: [],
      update: [],
      delete: {
        ids: []
      }
    }
  };

  const formatWirelessData = structuredClone(wirelessData);
  const lableFields = [
    'wirelessSchedule',
    'macFilter',
    'ipFilter',
    'captivePortalName',
  ];

  for (const item of formatWirelessData) {
    for (const field of lableFields) {
      if (item?.[field] === 'disabled') {
        item[field] = null;
      }
    }
  }

  formatWirelessData
  .filter(ssid => !ssid.isWaitingRemove || !ssid.isWaitingCreate) // Exclude unsaved created SSIDs that are also deleted temporarily.
  .forEach(ssid => {
    if (ssid.isWaitingRemove) {
      payload.data.delete.ids.push(ssid.id);
    } else {
      const isOpenType = ["OPEN", "ENHANCE_OPEN", "ENHANCE_OPEN+OPEN"].includes(ssid.security);
      const notSupportPassword = ["OPEN", "ENHANCE_OPEN", "ENHANCE_OPEN+OPEN", "WPA/WPA2-ENTERPRISE", "WPA2-ENTERPRISE", "WPA3-ENTERPRISE"].includes(ssid.security);

      const securityConfig = securityTypeConfig[ssid.security] || {
        wpaMode: { display: "", value: "" },
        encryption: "",
      };

      const {
        pmfState,
        ...formDataWithoutPmf
      } = ssid;

      const newSSID = {
        ...formDataWithoutPmf,
        wpaMode: isOpenType ? null : securityConfig.wpaMode?.value || "",
        encryption: isOpenType ? null : securityConfig.encryption || "",
        password: notSupportPassword ? null : formDataWithoutPmf.password || "",
      }

      if (ssid.isWaitingCreate) {
        payload.data.create.push(newSSID);
      } else {
        payload.data.update.push(newSSID);
      }

    }
  })

  if (isEmpty(payload.data.create) && isEmpty(payload.data.update) && isEmpty(payload.data.delete.ids)) return null;
  if (isEmpty(payload.data.delete.ids)) delete payload.data.delete;

  return payload;
}